import { Star } from "@phosphor-icons/react";

export default function StarRating({ value = 0, size = 16, showValue = false, count }) {
  const full = Math.round(value);
  return (
    <span className="inline-flex items-center gap-1.5" data-testid="star-rating">
      <span className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            size={size}
            weight={i <= full ? "fill" : "regular"}
            className={i <= full ? "text-amber-400" : "text-muted-foreground/40"}
          />
        ))}
      </span>
      {showValue && <span className="text-sm font-semibold">{Number(value).toFixed(1)}</span>}
      {count != null && <span className="text-sm text-muted-foreground">({count})</span>}
    </span>
  );
}
